import { ItandiIllust } from "@itandi/brand-ui/ItandiIllust";
import type { FC } from "react";
import Styles from "./VendorWithoutAuthHeader.module.scss";

export const VendorWithoutAuthHeader: FC = () => (
	<header className={Styles.BBHeader} id="header">
		<nav className={Styles.FirstNav}>
			<span className={Styles.ItandiBBLogo}>
				<ItandiIllust variant="itandiLogo" />
			</span>
		</nav>
	</header>
);
